
export interface IWatchVideoConfig {
    isIconHide?: boolean;
    autoVideoModal?: boolean;
    videoUrl?: string;
    showBenefits?: boolean;
    benefitsHeading?: string;
    benefitsList?: string[];
}

export const DEFAULT_WATCH_VIDEO_CONFIG: IWatchVideoConfig = {
    isIconHide: false,
    autoVideoModal: false,
    videoUrl: '',
    showBenefits: false,
    benefitsHeading: '',
    benefitsList: []
};
